import styled from 'styled-components'
import Input from './../../shahrzad-assets/shared_components/Input'
import { CSelect } from '@/shahrzad-assets/shared_components/CSelect'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import useGetGroupsRoles from '@/hooks/FamilyProfile/useGetGroupsRoles'
import { FC, useEffect, useState } from 'react'
import MobileDatePicker from '@/shahrzad-assets/shared_components/MobileDatePicker'
import useCreateUser from '@/hooks/FamilyProfile/useCreateUser'

interface IProps {
  groupId: number
  groupTypeId: number
  parentBirthDate: string
  parentNationalCode: string
  parentId: number
  groupName: string
}

const SendInvitationModal: FC<IProps> = ({ groupId, groupTypeId, parentBirthDate, parentNationalCode, parentId, groupName}) => {
  const [nationalCode, setNationalCode] = useState('')
  const [roleId, setRoleId] = useState('')
  const [memberBirthDate, setMemberBirthDate] = useState('')
  const { fetchGroupsRoles, roles } = useGetGroupsRoles()
  const { fetchCreateUser, createUserLoading } = useCreateUser()

  useEffect(() => {
    fetchGroupsRoles({ typeId: groupTypeId })
  }, [])

  const roleOptions = roles?.map((role) => {
    return { value: role?.id, label: role?.title }
  })

  const sendInvitation = () => {
    fetchCreateUser({
      memberRoleId: roleId,
      groupId,
      parentNationalCode,
      parentBirthDate,
      childNationalCode: nationalCode,
      childBirthDate: memberBirthDate,
      isOwner: true,
      parentId,
    })
  }

  return (
    <Content>
      <p>
        برای اضافه کردن عضو جدید به گروه {groupName} بعد از وارد کردن اطلاعات زیر
        یک دعوت‌نامه ارسال خواهد شد.
      </p>
      <Inputs>
        <Input
          value={nationalCode}
          onChange={(value) => setNationalCode(value)}
          type='number'
          label='کد ملی عضو جدید'
          id='national_code'
        />
        <MobileDatePicker
          onChange={(value) => setMemberBirthDate(value)}
          hasDefaultValue={false}
          placeHolder='تاریخ تولد'
        />
        <CSelect
          options={roleOptions}
          value={roleId}
          onChange={(value) => setRoleId(value)}
          label='نسبت عضو جدید'
          placeholder=''
          className='py-1 mt-1'
        />
      </Inputs>
      <CustomButton onClick={sendInvitation} loading={createUserLoading} width='100%'>
        ارسال دعوت نامه
      </CustomButton>
    </Content>
  )
}

export default SendInvitationModal

const Content = styled.div`
  padding: ${dimens.SPACING_M};
`
const Inputs = styled.div`
  margin: ${dimens.SPACING_XL} 0;
`
